import React from 'react';


export function BaseIconComponent({
    children,
    width = 32,
    height = 32,
    className = '',
    viewBox = `0 0 ${width} ${height}`
}) {
    return (
        <svg
            className={`icon resource-icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            viewBox={viewBox}
            focusable="false"
            height={height}
            width={width}
            role="img"
        >
            {children}
        </svg>
    )
};